import type { OverlayCloseReason } from "./useOverlayStack";
import { useOverlayStack } from "./useOverlayStack";
import ConfirmOverlay from "../components/overlay/ConfirmOverlay.vue";

export type ConfirmOptions = {
  variant?: "default" | "danger";
  title: string;
  subtitle?: string | null;
  body?: string | null;
  confirmLabel?: string;
  cancelLabel?: string;
  closeOnScrim?: boolean;
};

export function useConfirm() {
  const overlays = useOverlayStack();

  function confirm(options: ConfirmOptions): Promise<boolean> {
    return new Promise((resolve) => {
      let done = false;

      const id = overlays.push({
        kind: "confirm",
        component: ConfirmOverlay,
        props: {
          ...options,
          onConfirm: () => {
            if (done) return;
            done = true;
            resolve(true);
            overlays.close(id, "action");
          },
          onCancel: () => {
            if (done) return;
            done = true;
            resolve(false);
            overlays.close(id, "action");
          }
        },
        onClose: (_reason: OverlayCloseReason) => {
          if (done) return;
          done = true;
          resolve(false);
        }
      });
    });
  }

  return { confirm };
}

